import { Injectable } from '@angular/core';
import { MoldAuthService } from '../../../../common/mold/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class HosesMoldAuthService extends MoldAuthService {
  override readonly addEditRoles = [
    'Chief',
    'Admin',
    'HosesAdmin',
    'HosesChief',
    'HosesEngineer',
  ];

  override setStatus(): boolean {
    return this.lookForRolesNeeded([
      ...this.addEditRoles,
      'HosesLeader',
      'HosesSupervisor',
      'HosesEngineer',
    ]);
  }

  editLocation(): boolean {
    return super.editLocation() || this.lookForRolesNeeded(['HosesAdmin']);
  }
}
